import { Star, Heart, Circle, Square } from "lucide-react";

const SHAPES = [
  { Icon: Star, color: "#E8A800" },
  { Icon: Heart, color: "#D7352B" },
  { Icon: Circle, color: "#2E7CD6" },
  { Icon: Square, color: "#43A047" },
];

export const Marquee = ({ items, className = "", dark = false }) => (
  <div
    data-testid="editorial-marquee"
    className={`overflow-hidden whitespace-nowrap py-4 border-y ${
      dark ? "bg-forest text-cream border-forest" : "bg-sand/70 text-forest border-bone"
    } ${className}`}
  >
    <div className="inline-flex animate-marquee will-change-transform">
      {[0, 1].map((dup) => (
        <span key={dup} className="flex items-center" aria-hidden={dup === 1}>
          {items.map((item, i) => {
            const S = SHAPES[i % SHAPES.length];
            return (
              <span key={i} className="flex items-center font-accent font-medium text-sm sm:text-base tracking-wide">
                <span className="mx-6 sm:mx-10">{item}</span>
                <S.Icon className="w-4 h-4" style={{ color: S.color }} fill={S.color} />
              </span>
            );
          })}
        </span>
      ))}
    </div>
  </div>
);
